<template>
    <div class="pc-page">
        <div class="system_main" style="padding-top: 260px">
            <div class="line">学习潜力、学习动力、学习效力、心理健康对学生的学习力水平有重要的影响</div>
            <div class="list">
                <li class="item item_scale item_ql cur" style="border-color:#5f8ceb;background: #5f8ceb;">
                    <router-link to="/learningAbility/learningPotential" class="box">
                        <em class="icon"></em>
                        <h5 class="title" style="color:#FD493B">学习潜力</h5>
                    </router-link>
                </li>
                <li class="item   item_dl " >
                    <a class="box" style="cursor:auto">
                        <em class="icon"></em>
                        <!--<h5 class="title" style="color:#117BC4">学习动力</h5>-->
                        <h5 class="title" >学习动力</h5>
                    </a>
                </li>
                <li class="item  item_xl " >
                    <a  class="box" style="cursor:auto">
                        <em class="icon"></em>
                        <!--<h5 class="title" style="color:#3AB0BE">学习效力</h5>-->
                        <h5 class="title" >学习效力</h5>
                    </a>
                </li>
                <li class="item   item_xljk ">
                    <a  class="box" style="cursor:auto">
                        <em class="icon"></em>
                        <!--<h5 class="title" style="color:#E72B64">心理健康</h5>-->
                        <h5 class="title">心理健康</h5>
                    </a>
                </li>
                <!--<div class="show" @click="jump()">-->
                    <!--查看报告-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [ 'message' ],
        data() {
            return {
                isShowjihuoka: false,
                src: "",
                serial_no: '',
                // 记录状态
                zhuangtai: '',
            }
        },
        methods: {
            jump(){
                this.$router.push('/learningreport')
            }
        },
        created() {
        }
    }
</script>

<style scoped>
    .show{
        position: absolute;
        right: 0;
        top:-120px;
        width: 120px;
        height: 35px;
        border-radius: 17px;
        line-height: 35px;
        background: #FFFFFF;
        color:#3A95F0;
        font-size: 16px;
        cursor: pointer;
    }
    .line{
        width: 1200px;
        margin: 0 auto 40px;
        font-size: 18px;
        text-align: center;
        color:#fff;
    }
</style>
